import { modifier } from 'ember-modifier';
import Utils from '../utils/utils';
/**
 * Load an svg when lastUpdateDate changes
 */
export default modifier(
    // eslint-disable-next-line no-unused-vars
    function loadSvg(element, properties, { location, handleSvgRender, lastUpdateDate }) {
        if (location) Utils.loadSvg(location, element, handleSvgRender);
    },
    { eager: false },
);
